import classNames from "classnames/bind";
import React from "react";
import { Button } from "../Button";
import { Skeleton } from "../Skeleton";
import styles from "./CodeBlock.module.scss";
import type { CodeBlockProps } from "./types";

const cx = classNames.bind(styles);

/**
 * Renders a pre block with optional copy button in the top right. Use for
 * displaying code or commands. Pass onCopy to show the copy button and handle
 * copy behavior in the consumer.
 */
const CodeBlock = ({
  children,
  onCopy,
  isDisabled = false,
  isLoading = false,
  isBusy = false,
}: CodeBlockProps) => {
  const showCopyButton = typeof onCopy === "function";

  return (
    <Skeleton
      isLoading={isLoading}
      isBusy={isBusy}
    >
      <div className={cx("wrapper", showCopyButton && "wrapper--with-copy")}>
        {showCopyButton && (
          <Button
            className={cx("copy-button")}
            icon="copy"
            variant="outline"
            onClick={onCopy}
            disabled={isDisabled}
            title="Copy to clipboard"
          />
        )}
        <pre className={cx("pre")}>{children}</pre>
      </div>
    </Skeleton>
  );
};

CodeBlock.displayName = "CodeBlock";

export default CodeBlock;
